module.exports = __webpack_public_path__ + "static/media/logo-linkedin.8dc04bcd.svg";